import React, { createRef, RefObject } from 'react';
import parse from 'html-react-parser';
//components
import LayoutFull from '../../components/LayoutFull';
import Confetti from 'react-confetti';
import SEO from '@exp/common/src/components/seo/SEO';
import Image from '@exp/common/src/components/image/Image';
import IconCardFloatingGroup from '@exp/common/src/components/card-groups/IconCardsFloatingGroup';
import {
  CardsExpendableSteps,
  CardsExpendableStepsHeading,
  CardsExpendableStepsBody,
} from '@exp/common/src/components/cards-expandable/CardsExpendableSteps';
import SpotIconCardsGroup from '@exp/common/src/components/card-groups/SpotIconCardsGroup';
import DisclosureWithSymbol from '@exp/common/src/components/disclosure-with-symbol/DisclosureWithSymbol';
import Accordion from 'react-bootstrap/Accordion';
import StickyBanner from '@exp/common/src/components/sticky-banner/StickyBanner';
import BoostScore from '@exp/common/src/components/boost-score/BoostScore';
import BoostMap from '@exp/common/src/components/boost-map/BoostMap';
import Picture from '@exp/common/src/components/picture/Picture';
// scripts
import { formRegistrationUrl, refRegistrationParams } from '@exp/common/src/scripts/registration';
import { imageWithPrefix, ifMobile } from '@exp/common/src/scripts/helpers';
import { breakpoints } from '@exp/common/src/scripts/media';
//data
import { cpScoreBoostContent } from '../../content/cprd-score-boost';
import { ficoShort, scoreBoostResults } from '@exp/common/src/documents/disclosures/regulatory';
import { IHeadingCopyGroup } from '@exp/common/src/interfaces/generic';
// styles
import '../../styles/cprd-score-boost.scss';

export class ScoreBoost extends React.Component {
  stickyBannerRef: RefObject<any>;
  constructor(props: any) {
    super(props);
    this.stickyBannerRef = createRef();
  }
  state = { run: false };
  componentDidMount() {
    setTimeout(
      () => {
        this.setState(() => ({
          run: true,
        }));
      },
      ifMobile() ? 200 : 650,
    );
    setTimeout(
      () => {
        this.setState(() => ({
          run: false,
        }));
      },
      ifMobile() ? 4000 : 9000,
    );
  }

  render() {
    return (
      <LayoutFull tradeMarkFootNote="<sup>Ω</sup>">
        <section
          id="heroboost"
          className="overflow-hidden">
          <div className="container text-white container-sm-py position-relative">
            {this.state.run && (
              <Confetti
                className="confetti"
                height={ifMobile() ? 700 : 850}
                width={ifMobile() ? 700 : 850}
                gravity={0.07}
                tweenDuration={ifMobile() ? 500 : 8000}
                initialVelocityX={4}
                initialVelocityY={5}
                numberOfPieces={ifMobile() ? 130 : 150}
                recycle={false}
                confettiSource={{
                  w: 0,
                  h: 0,
                  x: ifMobile() ? 350 : 550,
                  y: 150,
                }}
              />
            )}
            <div className="row mb-8 d-block clearfix">
              <div className="col-md-6 col-lg-7 col-xxl-6 d-md-inline-block">
                <hgroup
                  role="group"
                  className="heading-sm-mb">
                  <h1>{parse(cpScoreBoostContent.headline)}</h1>
                  <p className="h4">{parse(cpScoreBoostContent.subheadline)}</p>
                </hgroup>
              </div>
              <div className=" col-md-6 col-lg-5 mb-5 mb-md-0 px-xl-6 float-md-end">
                <BoostScore
                  message={`<span className="badge me-1">New</span> Boost your credit with insurance!`}
                />
              </div>
              <div>
                <a
                  data-op="MQE"
                  ref={this.stickyBannerRef}
                  href={formRegistrationUrl({
                    offer: 'at_frsas111',
                    authType: '102',
                    refUrl: refRegistrationParams.boostOnboarding,
                  })}
                  className="btn btn-primary w-100 w-md-auto mb-3 btn-min-width">
                  {parse(cpScoreBoostContent.heroCTA)}
                </a>
                <p className="text-center text-md-start h7">
                  {cpScoreBoostContent.herounderCTAcopy}
                </p>
              </div>
            </div>
            <IconCardFloatingGroup
              content={cpScoreBoostContent.heroCards}
              variant="white"
              headingTag="h2"
            />
            <div className="disclosures-mt disclosures">
              <DisclosureWithSymbol disclosure={scoreBoostResults} />
            </div>
          </div>
        </section>
        <StickyBanner
          refElement={this.stickyBannerRef}
          btnCopy={cpScoreBoostContent.stickyBtnCopy}
          btnLink={formRegistrationUrl({
            offer: 'at_frsas111',
            authType: '102',
            refUrl: refRegistrationParams.boostOnboarding,
          })}
          heading={cpScoreBoostContent.stickyHeading}
        />
        <section id="logos-slider">
          <div className="container mt-4">
            <h2 className="h5 text-center">
              Popular bills that work with Experian Boost<sup>Ω</sup>
            </h2>
            <div className="overflow-hidden">
              <div className="slider-line d-flex justify-content-between">
                <Image
                  src="/logos/logo-netflix.svg"
                  alt="Logo Netflix."
                  lazyLoading
                  height="42"
                  width="97"
                />
                <Image
                  src="/logos/logo-disney-plus.png"
                  alt="Logo Disney Plus."
                  lazyLoading
                  height="42"
                  width="63"
                />
                <Image
                  src="/logos/logo-hulu.svg"
                  alt="Logo Hulu."
                  lazyLoading
                  height="42"
                  width="79"
                />
                <Image
                  src="/logos/logo-hbo.svg"
                  alt="Logo HBO."
                  lazyLoading
                  height="42"
                  width="66"
                />
                <Image
                  src="/logos/logo-att.svg"
                  alt="Logo At&t."
                  lazyLoading
                  height="42"
                  width="95"
                />
                <Image
                  src="/logos/logo-spectrum.svg"
                  alt="Logo Spectrum."
                  lazyLoading
                  height="42"
                  width="121"
                />
                <Image
                  src="/logos/logo-verizon.svg"
                  alt="Logo Verizon."
                  lazyLoading
                  height="42"
                  width="114"
                />
                <Image
                  src="/logos/logo-netflix.svg"
                  alt="Logo Netflix."
                  lazyLoading
                  height="42"
                  width="97"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-disney-plus.png"
                  alt="Logo Disney Plus."
                  lazyLoading
                  height="42"
                  width="63"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-hulu.svg"
                  alt="Logo Hulu."
                  lazyLoading
                  height="42"
                  width="79"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-hbo.svg"
                  alt="Logo HBO."
                  lazyLoading
                  height="42"
                  width="66"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-att.svg"
                  alt="Logo At&t."
                  lazyLoading
                  height="42"
                  width="95"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-spectrum.svg"
                  alt="Logo Spectrum."
                  lazyLoading
                  height="42"
                  width="121"
                  className="d-lg-none"
                />
                <Image
                  src="/logos/logo-verizon.svg"
                  alt="Logo Verizon."
                  lazyLoading
                  height="42"
                  width="114"
                  className="d-lg-none"
                />
              </div>
            </div>
          </div>
        </section>
        <section className="container-py">
          <div className="container">
            <h2 className="heading-mb col-lg-8 col-xl-6">{cpScoreBoostContent.secondary.title}</h2>
            <div className="row step-expandable-cards gx-lg-7">
              {cpScoreBoostContent.secondary.bullets.map((bullet, index) => (
                <CardsExpendableSteps
                  id={`booststep${index}`}
                  className="col-lg-4"
                  defaultToggle={index === 0}
                  key={index}>
                  <CardsExpendableStepsHeading step={`${index + 1}`}>
                    {parse(bullet.heading)}
                  </CardsExpendableStepsHeading>
                  <CardsExpendableStepsBody>
                    <p>{parse(bullet.subcopy)}</p>
                    <Picture
                      className="w-lg-100 mx-auto"
                      sources={[
                        {
                          srcSet: `${bullet.image}-d.webp 1.5x`,
                          media: 'xl',
                          width: '386',
                          height: '279',
                        },
                        {
                          srcSet: `${bullet.image}-d.webp`,
                          media: 'sm',
                          width: '327',
                          height: '236',
                        },
                      ]}
                      image={{
                        src: `${bullet.image}-m.webp`,
                        width: '268',
                        height: '194',
                        className: 'img-fluid',
                        alt: bullet.image,
                      }}
                      lazyLoading
                    />
                  </CardsExpendableStepsBody>
                </CardsExpendableSteps>
              ))}
            </div>
            <div className="text-center mt-6 mt-lg-7">
              <a
                data-op="SEC"
                href={formRegistrationUrl({
                  offer: 'at_frsas111',
                  authType: '102',
                  refUrl: refRegistrationParams.boostOnboarding,
                })}
                className="btn btn-primary w-100 w-md-auto btn-min-width">
                {cpScoreBoostContent.secondary.btn}
              </a>
            </div>
            <div className="disclosures-mt disclosures">
              <DisclosureWithSymbol disclosure={ficoShort} />
            </div>
          </div>
        </section>
        <section className="bg-marian-blue container-py">
          <div className="container">
            <h2 className="heading-mb col-lg-8 col-xl-6">
              {cpScoreBoostContent.spoticonsSection.title}
            </h2>
            <SpotIconCardsGroup content={cpScoreBoostContent.spoticonsSection.steps} />
            <div className="text-center mt-6 mt-lg-7">
              <a
                data-op="THR"
                href={formRegistrationUrl({
                  offer: 'at_frsas111',
                  authType: '102',
                  refUrl: refRegistrationParams.boostOnboarding,
                })}
                className="btn btn-primary w-100 w-md-auto">
                {cpScoreBoostContent.spoticonsSection.btn}
              </a>
            </div>
          </div>
        </section>

        <div className="container border-bottom container-py">
          <div className="row justify-content-xl-center">
            <div className="col-xl-10">
              <h2 className="heading-mb text-center">{cpScoreBoostContent.mapTitle}</h2>
              <BoostMap />
            </div>
          </div>
        </div>
        <section>
          <div className="container container-py">
            <div className="row justify-content-xl-center">
              <div className="col-12 col-xl-10">
                <hgroup
                  role="group"
                  className="heading-mb text-lg-center">
                  <p className="eyebrow-text text-gray pb-2">Frequently asked questions</p>
                  <h2>{cpScoreBoostContent.faq.title}</h2>
                </hgroup>
                <Accordion
                  alwaysOpen
                  flush
                  className="accordion-plus-icon">
                  {cpScoreBoostContent.faq.content.map(
                    (element: IHeadingCopyGroup, index: number) => (
                      <Accordion.Item
                        key={index}
                        eventKey={`${index}-faq`}>
                        <h3 className="accordion-header h5">
                          <Accordion.Button
                            className="py-4"
                            aria-controls={`${index}-faq-b`}
                            id={`${index}-faq-h`}>
                            {parse(element.heading)}
                          </Accordion.Button>
                        </h3>
                        <Accordion.Body
                          id={`${index}-faq-b`}
                          aria-labelledby={`${index}-faq-h`}
                          role="region">
                          {parse(element.subcopy)}
                        </Accordion.Body>
                      </Accordion.Item>
                    ),
                  )}
                </Accordion>
              </div>
            </div>
          </div>
        </section>
      </LayoutFull>
    );
  }
}

export default ScoreBoost;

export const Head = () => {
  return (
    <>
      <body
        data-op="EXP-PRD-BST"
        data-section="ecom-report-score"
        data-category="score"
      />
      <SEO
        title="Experian Boost - Improve Your Credit Scores for Free"
        description="Boost your Credit Scores and raise your FICO® Score instantly for free. Millions of points already boosted across America.">
        <meta
          property="og:title"
          content="Experian Boost - Improve Your Credit Scores for Free"
        />
        <meta
          property="og:description"
          content="Boost your Credit Scores and raise your FICO® Score instantly for free. Millions of points already boosted across America."
        />
        <meta
          property="og:url"
          content="https://www.experian.com/consumer-products/score-boost.html"
        />
        <meta
          property="og:image"
          content={imageWithPrefix('/social/social-experian-boost.webp')}
        />
        <meta
          name="twitter:title"
          content="Experian Boost - Improve Your Credit Scores for Free"
        />
        <meta
          name="twitter:description"
          content="Boost your Credit Scores and raise your FICO® Score instantly for free. Millions of points already boosted across America."
        />
        <meta
          name="twitter:image"
          content={imageWithPrefix('/social/social-experian-boost.webp')}
        />
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <link
          rel="alternate"
          href="https://www.experian.com/consumer-products/score-boost.html"
          hrefLang="en-us"
        />
        <link
          rel="alternate"
          href="https://www.experian.co.uk/consumer/experian-boost.html"
          hrefLang="en-gb"
        />
        <link
          rel="preload"
          as="image"
          href={imageWithPrefix(`/graphics/graphic-score-band-good-white.svg`)}
          media={`(min-width: ${breakpoints.md}px)`}
        />
        <link
          rel="preload"
          as="image"
          href={imageWithPrefix(`/graphics/graphic-score-band-good-white-horiz.svg`)}
          media={`(max-width: ${breakpoints.md - 1}px)`}
        />
      </SEO>
    </>
  );
};
